import styled from 'styled-components';

export const MakeModelsStyled = styled.div`
  display: flex; 
  .boxHeader {
    padding: 0 0 20px 0;
  }
  .targetingDeviceMakeModelsContainer {
    &__unknownIncluded {
      .checkboxText {
        color: ${props => props.theme.uiColors.textBodyDefault};
      }
    }
  }
`;
